import { installObjectExtension } from './bindEvent'
import {
  Direction,
  InteractionManager,
  LoaderModule,
  ModelLoader,
  OutlinePassExtend,
  SceneContext,
  SceneControl,
  TWEEN,
  TransformControls,
  create3DLabel,
  createLabel,
  createTransformControls,
  dom,
  use,
  utils,
} from './export'

export * from 'gsap'
export * as lib from 'three-stdlib'
export * from 'three'
export * from 'three-mesh-bvh'
export { SplatMesh, SparkRenderer } from '@sparkjsdev/spark'
export {
  CSS2DObject,
  CSS2DRenderer,
  CSS3DObject,
  CSS3DRenderer,
  DRACOLoader,
  GLTFLoader,
  GUI,
  Line2,
  LineGeometry,
  LineMaterial,
  OctreeHelper,
  OrbitControls,
  OutputPass,
  RoomEnvironment,
  Stats,
  Water,
  Water2,
  BufferGeometryUtils,
} from './threeCell'

export {
  useComposerFrame,
  useLoader,
  useScene,
  useSubComposerFrame,
  useframe,
  useframeAfter,
} from './core/use'

export {
  EControlMode,
  UniversalControls,
} from './core/control/UniversalControls'
export type {
  ControlsType,
  ControlsOption,
  UniversalControlsOptions,
} from './core/control/UniversalControls'

installObjectExtension()

export {
  Direction,
  InteractionManager,
  LoaderModule,
  ModelLoader,
  OutlinePassExtend,
  SceneContext,
  SceneControl,
  TWEEN,
  TransformControls,
  create3DLabel,
  createLabel,
  createTransformControls,
  dom,
  use,
  utils,
}
